import { asPercent } from "@silo/utils";
import { cn } from "../../../utils/class-names";
import { getDebtRewardsStateColor } from "../../apr-display-v2/utils";
import { DebtMetrics } from "./types";

interface TotalAprProps {
  className?: string;
  metrics: DebtMetrics;
}

export function TotalApr({ className, metrics }: TotalAprProps): JSX.Element {
  const { debtRewardsState, totalDebtApr, isDebtAprFixed, showFixedLabel } =
    metrics;

  return (
    <div
      className={cn(
        "flex flex-col items-end font-mono text-2xl font-medium",
        isDebtAprFixed ? "text-amber-300" : "text-white",
        getDebtRewardsStateColor(debtRewardsState),
        className
      )}
    >
      {asPercent(totalDebtApr)}

      {showFixedLabel && <div className="font-sans text-sm">Fixed</div>}
    </div>
  );
}
